/* eslint-disable no-new */
import Vue from 'vue'
import App from './App.vue'
import store from '../store'
import router from '../router'
import Toasted from 'vue-toasted'

import vmodal from 'vue-js-modal'
import * as firebase from 'firebase/app'
import 'firebase/auth'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faPlus, faShareAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faShareAlt, faPlus)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(vmodal)
Vue.use(Toasted)
require('../assets/style.css')

require('typeface-quicksand')

// Initialize Firebase
const firebaseConfig = {
  apiKey: 'AIzaSyAQ5LD2z6cC8H0hLcCMwOndZSYkUnbamh0',
  authDomain: 'read-to-remember.firebaseapp.com',
  databaseURL: 'https://read-to-remember.firebaseio.com',
  projectId: 'read-to-remember',
  storageBucket: 'read-to-remember.appspot.com',
  messagingSenderId: '866296044896',
  appId: '1:866296044896:web:f9c4b15afa61aa97099205',
  measurementId: 'G-B399B3JX5H'
}
firebase.initializeApp(firebaseConfig)
let app: any = ''
firebase.auth().onAuthStateChanged((user) => {
  if (!app) {
    app = new Vue({
      router,
      store,
      el: '#app',
      render: h => h(App)
    })
  }
})
require('../assets/js/analyticsLoader.js')
